export default {
    getList: {
        default: [{
            site_name: "台州中心医院",
            id: 5,
            grantor_id: 4,
            grantee_name: "台州博越(美创)信息技术有限公司",
            grantor_name:'杭州美创科技有限公司',
            status: 2
        }, {
            site_name: "台州恩泽医疗中心",
            id: 7,
            grantor_id: 4,
            grantee_name: "台州博越(美创)杭州美创科技有限公司",
            grantor_name:'台州博越(美创)信息技术有限公司',
            status: 2
        }, {
            site_name: "仙居县社会保险事业管理中心",
            id: 8,
            grantor_id: 4,
            grantee_name: "杭州美创科技有限公司",
            grantor_name:'台州博越(美创)信息技术有限公司',
            status: 1
        }]
    }
}